import { render, staticRenderFns } from "./InvalidFormatMessage.vue?vue&type=template&id=27e80d44"
import script from "./InvalidFormatMessage.vue?vue&type=script&lang=js"
export * from "./InvalidFormatMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports